import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../lib/seo';

export function NotFound() {
  return (
    <>
      <SEO 
        title="404 - Siden blev ikke fundet | Fodtid"
        description="Den side, du leder efter, findes desværre ikke. Gå tilbage til forsiden eller find dine ønskede fodbehandlinger hos Fodtid."
      />

      <section className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-8 bg-canvas border-b border-brand-border">
        <div className="max-w-xl mx-auto text-center space-y-6 bg-surface/50 p-8 sm:p-12 rounded-3xl border border-brand-border shadow-xs">
          
          <div className="w-20 h-20 rounded-full bg-surface border border-brand-border text-brand-accent flex items-center justify-center text-4xl mx-auto shadow-xs">
            <i className="fa-solid fa-compass" aria-hidden="true" />
          </div>

          <div className="space-y-2">
            <span className="text-xs uppercase font-bold tracking-widest text-brand-charcoal bg-surface px-3 py-1 rounded-full border border-brand-border">
              Fejl 404 • Siden findes ikke
            </span>
            <h1 className="font-serif text-3xl sm:text-4xl font-bold text-brand-charcoal">
              Hov, her trådte du ved siden af
            </h1>
            <p className="text-brand-muted text-sm leading-relaxed">
              Vi kunne desværre ikke finde den side, du ledte efter. Den kan være flyttet, eller adressen er tastet forkert.
            </p>
          </div>

          {/* Useful links */}
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-brand-charcoal hover:bg-black text-canvas font-bold px-6 py-3.5 rounded-full text-xs uppercase tracking-wider shadow transition-colors"
            >
              <i className="fa-solid fa-house text-brand-accent" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/ydelser"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-canvas hover:bg-surface text-brand-charcoal font-bold px-6 py-3.5 rounded-full text-xs uppercase tracking-wider transition-colors border border-brand-border"
            >
              <span>Se vores ydelser</span>
            </Link>
          </div>

          <div className="pt-6 border-t border-brand-border text-xs text-brand-muted">
            Brug for akut hjælp? Ring direkte til os på <a href="tel:82821010" className="text-brand-charcoal font-bold hover:underline whitespace-nowrap">82 82 10 10</a>
          </div>

        </div>
      </section>
    </>
  );
}
